// extracted by mini-css-extract-plugin
module.exports =  {"seoAnchor":"pl__SEOAnchor-module__seoAnchor___yGOcM"};